import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";

const CashDetailMain = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} title={t("CreatedDate")} disabled={true} />
        </Col>
      </Row>
    </>
  );
};

export default CashDetailMain;
